type UrlStateLocation = {
  search: string;
  hash: string;
};

export function readUrlStateParam(location: UrlStateLocation, name: string): string {
  const fragmentValue = new URLSearchParams(location.hash.replace(/^#/, '')).get(name)?.trim();
  if (fragmentValue) {
    return fragmentValue;
  }
  return new URLSearchParams(location.search).get(name)?.trim() ?? '';
}
